(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-portal-hero"] && !Shopify.designMode) return;
  try {
    
function setupAlarisMotion(scope=document){
  scope.querySelectorAll('[data-az-portal]').forEach(hero=>{
    const button=hero.querySelector('.az-motion-toggle');
    if(!button||button.dataset.ready)return;
    button.dataset.ready='true';
    button.hidden=false;
    button.addEventListener('click',()=>{
      const paused=hero.classList.toggle('is-paused');
      button.setAttribute('aria-pressed',String(paused));
      button.textContent=paused?button.dataset.play:button.dataset.pause;
    });
  });
}
setupAlarisMotion();
document.addEventListener('shopify:section:load',event=>setupAlarisMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
